import { useEffect, useState } from "react";
import { LOGO_URL } from "../data/site";

// Intro d'obertura: el logotip apareix a gran format amb un fade elegant i després revela el hero.
// S'auto-retira sempre (temporitzador) i només es mostra un cop per sessió.
export const Intro = () => {
  const [phase, setPhase] = useState(() =>
    typeof window !== "undefined" && sessionStorage.getItem("ofc_intro_seen") ? "done" : "in"
  );

  useEffect(() => {
    if (phase === "done") {
      document.body.style.overflow = "";
      return;
    }
    document.body.style.overflow = "hidden";
    const tOut = setTimeout(() => setPhase("out"), 3600);
    const tDone = setTimeout(() => {
      sessionStorage.setItem("ofc_intro_seen", "1");
      setPhase("done");
    }, 4700);
    return () => {
      clearTimeout(tOut);
      clearTimeout(tDone);
      document.body.style.overflow = "";
    };
  }, [phase]);

  if (phase === "done") return null;

  return (
    <div
      data-testid="intro-overlay"
      onClick={() => setPhase("out")}
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-ofc-black transition-opacity duration-[900ms] ease-out ${
        phase === "out" ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="flex flex-col items-center px-6">
        <img
          src={LOGO_URL}
          alt="Orbis Forum Català"
          className="w-[340px] sm:w-[460px] md:w-[600px] lg:w-[680px] max-w-[90vw] h-auto object-contain ofc-intro-logo select-none"
          draggable="false"
        />
        <div className="ofc-intro-line mt-1 h-px bg-gradient-to-r from-transparent via-ofc-gold to-transparent" />
      </div>
    </div>
  );
};
